import React from 'react';
import { Link } from 'react-router-dom';
import { dbtConfig } from '../../config/dbt';

/**
 * DbtConnectionCard Component
 * Displays a single dbt connection with status and actions
 */
const DbtConnectionCard = ({ connection, onValidate, onSync }) => {
  const getStatusBadge = (status) => {
    const badgeClass = dbtConfig.statusBadgeVariants[status] || 'badge-ghost';
    return <span className={`badge ${badgeClass} badge-sm`}>{status}</span>;
  };

  const getTypeBadge = (type) => {
    const isCore = type === dbtConfig.connectionTypes.CORE;
    return (
      <span className="badge badge-outline badge-sm">
        {isCore ? 'dbt Core' : 'dbt Cloud'}
      </span>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Never';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="bg-white shadow-md hover:shadow-lg transition-shadow rounded-lg">
      <div className="p-6">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <h3 className="card-title text-lg">
              {connection.name}
            </h3>
            {connection.description && (
              <p className="text-sm text-base-content/70 mt-1">
                {connection.description}
              </p>
            )}
            <div className="flex gap-2 mt-3">
              {getTypeBadge(connection.connection_type)}
              {getStatusBadge(connection.validation_status)}
            </div>
            {connection.last_validated_at && (
              <p className="text-xs text-base-content/50 mt-2">
                Last validated: {formatDate(connection.last_validated_at)}
              </p>
            )}
          </div>

          <div className="flex gap-2">
            <Link
              to={`/dbt/connections/${connection.id}`}
              className="btn btn-sm btn-primary"
            >
              View
            </Link>
            {connection.validation_status !== dbtConfig.validationStatus.VALID && (
              <button
                onClick={() => onValidate(connection.id)}
                className="btn btn-sm btn-outline"
              >
                Validate
              </button>
            )}
            {connection.connection_type === dbtConfig.connectionTypes.CORE && (
              <button
                onClick={() => onSync(connection.id)}
                className="btn btn-sm btn-ghost"
              >
                Sync
              </button>
            )}
          </div>
        </div>

        {/* Connection-type specific info */}
        <div className="mt-4 pt-4 border-t border-base-300">
          {connection.connection_type === dbtConfig.connectionTypes.CORE ? (
            <div className="text-xs text-base-content/60 space-y-1">
              {connection.project_path && (
                <div>
                  <span className="font-semibold">Project Path:</span>{' '}
                  <code className="bg-base-200 px-1 rounded">{connection.project_path}</code>
                </div>
              )}
              {connection.target_name && (
                <div>
                  <span className="font-semibold">Target:</span> {connection.target_name}
                </div>
              )}
            </div>
          ) : (
            <div className="text-xs text-base-content/60 space-y-1">
              {connection.account_id && (
                <div>
                  <span className="font-semibold">Account ID:</span> {connection.account_id}
                </div>
              )}
              {connection.project_id && (
                <div>
                  <span className="font-semibold">Project ID:</span> {connection.project_id}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DbtConnectionCard;
